import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact gene stack text as it appears in the source file (matched case-insensitively).',
  },
  {
    key: 'geneStackId',
    label: 'Gene Stack',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/gene-stacks',
    displayKey: 'geneStackName',
  },
];

// Admin view of GeneStackAlias — same purpose as ProductAliasManagement, for
// the Gene Stack field instead of Product.
const GeneStackAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Gene Stack Map"
    icon={<LinkIcon />}
    apiPath="/api/gene-stack-aliases"
    fields={fields}
    entityLabel="Gene Stack Alias"
    softDelete={false}
  />
);

export default GeneStackAliasManagement;
